import { render, staticRenderFns } from "./TagModalForm.vue?vue&type=template&id=1a65e6d4"
import script from "./TagModalForm.vue?vue&type=script&lang=js"
export * from "./TagModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports